export class UsuarioModel {
  public idRol: number;
  public idEmpresa: number;
  public nombre: string;
  public apellidoPat: string;
  public apellidoMat: string;
  public genero: string;
  public correoElectronico: string;
  public celular: string;
  public contrasenia: string;
  public token: string;
  public nickName: string;
  public calle: string;
  public numero: string;
  public codigoPostal: string;
  public idCiudad: number;
  public telefonoFijo: string;

  constructor() { }
}